import { query } from '@/api/Query';

//https://slonopotam.net/v2/tags?filters[tag|contains]=error&page[size]=5&page[number]=1
export const getTags = async ({ token, text, pageSize, pageNumber }) => {
  const queryParams = {
    'filters[tag|contains]': text,
    'page[size]': pageSize,
    'page[number]': pageNumber
  };

  try {
    return await query({
      method: 'GET',
      resource: 'tags',
      queryParams,
      token
    });
  } catch (e) {
    console.error(e);
    return { error: 'что-то пошло не так' };
  }
};

export const getTagsByProfile = async ({ token, profileId }) => {
  try {
    const res = await query({
      method: 'GET',
      resource: `profiles/${profileId}`,
      queryParams: { include: 'tags' },
      token
    });
    return { data: res.data.tags || [] };
  } catch (e) {
    console.error(e);
    return { error: 'что-то пошло не так' };
  }
};

export const updateTagApi = async ({ profileId, tagId, newName, token }) => {
  try {
    const res = await query({
      method: 'PATCH',
      resource: `profiles/${profileId}/tags/${tagId}`,
      type: 'tags',
      queryParams: { id: String(tagId), name: newName },
      token
    });
    return { status: 'ok', data: res.data };
  } catch (err) {
    console.error('updateTagApi', err);
    return { error: 'что-то пошло не так' };
  }
};

export const deleteTagApi = async ({ profileId, tagId, token }) => {
  try {
    const res = await query({
      method: 'DELETE',
      resource: `profiles/${profileId}/tags/${tagId}`,
      token
    });
    return { status: 'ok', data: res.data };
  } catch (err) {
    console.error('deleteTagApi', err);
    return { error: 'что-то пошло не так' };
  }
};
